import React from 'react';
import { SectionHeading } from './SectionHeading';
import { levelPacks } from '../data/landing';
export function LevelsSection() {
  return <section aria-labelledby="incluye" className="bg-cream-deep" data-id="element-125" data-mp="2te352ddr5wmn">
      
    </section>;
}